<div id="delta-sql-modal">
  <div class="header">
    <div class="label property-name">{{ 'DELTA_SQL_GENERATE' | translate }}</div>
    <div>
      <span (click)="closePopup()" (keyup.enter)="closePopup()" tabindex="0" aria-label="Close popup">
        <i class="pi pi-times-circle close-icon" style="font-size: 1.5rem"></i>
      </span>
    </div>
  </div>
  <div class="body">
    <p-splitter layout="vertical" [style]="{ height: 'calc(100% - 1rem)', width: '100%' }" [minSizes]="[10, 10]">
      <!-- Row 1 -->
      <ng-template pTemplate>
        <p-splitter [style]="{}">
          <!-- Left -->
          <ng-template pTemplate>
            <div class="schema-container ml-0">
              <label class="title-delta" for="monacoEditor1">
                {{ 'SCHEMA_1' | translate }}
                <i class="pi pi-info-circle" pTooltip="{{ 'DELTA_SQL_SCHEMA_1_INFO' | translate }}"></i>
              </label>
              <div class="editor-wrapper" #monacoWrapper1>
                <ngx-monaco-editor
                  id="monacoEditor1"
                  style="height: 100%; width: 100%"
                  (onInit)="onEditorInit($event, 1)"
                  [options]="editorOptions"
                  [(ngModel)]="originalSchema"
                  (ngModelChange)="onInputChange()"
                ></ngx-monaco-editor>
              </div>
            </div>
          </ng-template>

          <!-- Right  -->
          <ng-template pTemplate>
            <div class="schema-container mr-0">
              <label class="title-delta" for="monacoEditor2">
                {{ 'SCHEMA_2' | translate }}
                <i class="pi pi-info-circle" pTooltip="{{ 'DELTA_SQL_SCHEMA_2_INFO' | translate }}"></i>
              </label>
              <div class="editor-wrapper" #monacoWrapper2>
                <ngx-monaco-editor
                  id="monacoEditor2"
                  style="height: 100%; width: 100%"
                  (onInit)="onEditorInit($event, 2)"
                  [options]="editorOptions"
                  [(ngModel)]="changedSchema"
                  (ngModelChange)="onInputChange()"
                ></ngx-monaco-editor>
              </div>
            </div>
          </ng-template>
        </p-splitter>
      </ng-template>

      <!-- Row 2 -->
      <ng-template pTemplate>
        <div class="schema-container w-100 mx-0">
          <div class="generate-btn-grp">
            <div class="form-group pr-0">
              <p-select
                id="schemaType"
                [options]="schemaOptions"
                [(ngModel)]="schemaType"
                optionLabel="name"
              ></p-select>
              <button #generateButton class="btn btn-lg btn-primary pr-2" [disabled]="isDisabled ?? null">
                Generate Delta
                <i *ngIf="!isLoadingResponse"
                  ><span class="ai-badge"><svg-icon src="assets\images\svg\ai-datamodel-import.svg"></svg-icon></span
                ></i>
                <i *ngIf="isLoadingResponse" class="pi pi-sync" [ngClass]="{ 'pi-spin': isLoadingResponse }"></i>
              </button>
              <i
                class="pi pi-info-circle generate-info"
                pTooltip="{{ 'DELTA_SQL_GENERATE_BUTTON_INFO' | translate }}"
              ></i>
            </div>
          </div>

          <div class="action-btn-grp">
            <button
              #downloadButton
              type="button"
              class="btn p-0 m-0 border-0 bg-transparent text-primary"
              [disabled]="deltaSQLSchema?.trim() ? null : true"
            >
              Download
              <i class="pi pi-download"></i>
            </button>
            <button
              (click)="copyToClipboard()"
              type="button"
              class="btn p-0 m-0 border-0 bg-transparent text-primary"
              [disabled]="deltaSQLSchema?.trim() ? null : true"
            >
              Copy
              <i class="pi pi-copy"></i>
              <div
                #copyToast
                class="toast align-items-center border-primary text-primary bg-white position-absolute top-0 start-100 translate-middle-x mt-2 ms-2"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div class="d-flex">
                  <div class="toast-body py-1 px-2">Copied!</div>
                </div>
              </div>
            </button>
          </div>
          <label class="title-delta" for="monacoEditor3">
            {{ 'DELTA_SCHEMA' | translate }}
            <i class="pi pi-info-circle" pTooltip="{{ 'DELTA_SQL_DELTA_SCHEMA_INFO' | translate }}"></i>
          </label>
          <div class="editor-wrapper" #monacoWrapper3>
            <ngx-monaco-editor
              id="monacoEditor3"
              style="height: 100%; width: 100%"
              (onInit)="onEditorInit($event, 3)"
              [options]="editorOptions"
              [(ngModel)]="deltaSQLSchema"
              (ngModelChange)="onInputChange()"
            ></ngx-monaco-editor>
          </div>
        </div>
      </ng-template>
    </p-splitter>
    <div class="disclaimer-wrapper d-flex align-items-center">
      <div class="alert small p-0 m-0" role="alert">
        <i class="fa-solid fa-triangle-exclamation"></i> {{ 'DELTA_SQL_DISCLAIMER' | translate }}
        <i class="pi pi-info-circle" pTooltip="{{ 'DELTA_SQL_DISCLAIMER_INFO' | translate }}"></i>
      </div>
    </div>
  </div>
</div>
